export default __webpack_public_path__ + "static/14_31-5dfc105fd6171127e6faba2f6776f608.png";